<template>
  <private-gym-page id="index-page" name="home" :has_fab="false">

    <f7-block-title>
      Welkom {{ current_user.first_name }}!
    </f7-block-title>

    <f7-card class="card-raised">
      <f7-card-content :padding="false">
        <f7-list class="list-strong list-outline list-dividers">
          <f7-list-item panel-close="left" title="Jouw trainingen"  view=".view-main" link="/trainingen"></f7-list-item>
          <!--        <f7-list-item title="Workouts" link="#"></f7-list-item>-->
          <f7-list-item panel-close="left" title="Training inplannen"  view=".view-main" link="/account/calendar"></f7-list-item>
          <f7-list-item panel-close="left" title="Reserveringen"  view=".view-main" link="/account/reserveringen"></f7-list-item>
<!--          <f7-list-item link="#">Link 1</f7-list-item>-->
<!--          <f7-list-item link="#">Link 2</f7-list-item>-->
<!--          <f7-list-item link="#">Link 3</f7-list-item>-->
<!--          <f7-list-item link="#">Link 4</f7-list-item>-->
<!--          <f7-list-item link="#">Link 5</f7-list-item>-->
        </f7-list>
      </f7-card-content>
    </f7-card>
<!--    <f7-card class="card-raised">-->
<!--      <f7-card-content :padding="false">-->
<!--        <f7-list class="list-strong list-outline list-dividers">-->
<!--          <f7-list-item panel-close="left" title="Techniek training"  view=".view-main" link="/videos/techniek-training"></f7-list-item>-->
<!--          <f7-list-item panel-close="left" title="Workouts"  view=".view-main" link="/videos/workouts"></f7-list-item>-->
<!--          <f7-list-item panel-close="left" title="Eiland instructies"  view=".view-main" link="/videos/eiland-instructies"></f7-list-item>-->
<!--        </f7-list>-->
<!--      </f7-card-content>-->
<!--    </f7-card>-->

  </private-gym-page>
</template>

<script>

import TrainingSessionsList from "../components/training_sessions/TrainingSessionsList.vue";
import PageTopNavbar from "../components/nav/PageTopNavbar.vue";
import PrivateGymPage from "./_layouts/PrivateGymPage.vue";
import { f7, f7ready, theme } from 'framework7-vue';
import PgFab from "../components/general/PgFab.vue";

export default {
  components: {
    PrivateGymPage,
  },

  props: {
    f7route: Object,
    f7router: Object,
    has_fab: {default: false}
  },

  setup(props) {
    const { f7route, f7router } = props;
  },

  mixins: [],

  data: function () {
    return {
      //
    };
  },

  computed: {
    current_user() {
      return this.$store.state.current_user.data;
    },
    is_logged_in() {
      return this.$store.getters['current_user/token'].length > 0;
    },
  },

  created() {
    //
  },

  mounted() {
    if (this.is_logged_in) {
      // Redirect to account when missing NAW
        setTimeout(() => {
          if(this.$store.getters['current_user/missing_naw'] && !this.$store.getters['current_user/hasBeenRedirected']) {
            this.$store.dispatch('current_user/hasBeenRedirected', {});
            f7.views.main.router.navigate('/users/' + this.current_user.id);
          }
        }, 500);
    }
  },

  methods: {
    //
  },

  watch: {
    //
  }
};
</script>
